import { Form, FormField } from "@babackapp/ui/components/form";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right.ts";
import { SettingsFormPageButtonBar } from "@babackapp/react-hook-forms-components/form-page";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, useWatch } from "react-hook-form";
import PortalExchangeActivatedForm from "./portal-exchange-activated-form.tsx";
import {
  PortalExchangeFormSchema,
  PortalExchangeFormValues,
} from "./portal-exchange-card.tsx";
import useTranslation from "@babackapp/translations/use-translation";

type PortalExchangeFormProps = {
  defaultValues?: Partial<PortalExchangeFormValues>;
  onSubmit: (data: PortalExchangeFormValues) => void;
};

export default function PortalExchangeForm({
  onSubmit,
  defaultValues,
}: PortalExchangeFormProps) {
  const t = useTranslation();

  const form = useForm<PortalExchangeFormValues>({
    resolver: zodResolver(PortalExchangeFormSchema),
    defaultValues: {
      activated: false,
      reserveInventory: false,
      maxDifference: 0,
      minimalStock: 0,
      tagsForNewOrder: [],
      tagsForNotExchangeOrder: [],
      tagsForNotExchangeCreditOrder: [],
      reshippingHasToBePaid: false,
      exchangeWithOtherArticles: false,
      exchangeWithOtherArticlesPaymentButtonQuerySelector: "",
      shippingMethods: [],
      collections: [],
      ...defaultValues,
    },
  });

  try {
    if (localStorage.getItem("guillaume-debug") === "true") {
      console.log(form.formState);
    }
  } catch (e) {
    // do nothing, localStorage might not be available
    console.error("localStorage is not available", e);
  }

  const activated = useWatch({
    control: form.control,
    name: "activated",
  });

  const hasAdminRight = useViewerHasAtLeastAdminRights();

  const disabledAdmin = !hasAdminRight
    ? "You don't have permission to edit this"
    : false;

  const disabledActivation = !activated
    ? "You need to activate the exchange first"
    : false;

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col justify-start gap-8 mt-8"
      >
        <FormField
          control={form.control}
          name="activated"
          render={({ field }) => (
            <FormSwitch
              label={t("settings.exchange.fields.activated.title")}
              description={t("settings.exchange.fields.activated.description")}
              {...field}
              disabled={disabledAdmin}
            />
          )}
        />

        <PortalExchangeActivatedForm
          disabled={disabledAdmin || disabledActivation}
        />

        <SettingsFormPageButtonBar />
      </form>
    </Form>
  );
}
